import React from 'react';

const DeliveryAndRefunds: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-left">
      <h1 className="text-3xl font-bold mb-4">Delivery, Collection and Refunds</h1>
      <p className="text-gray-700 mb-6">Last updated: {new Date().getFullYear()}</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Delivery / Collection</h2>
      <p className="mb-4">We currently offer collection and may offer local delivery. Times provided at checkout are estimates.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Order issues</h2>
      <p className="mb-4">If something is wrong with your order, please speak to us as soon as possible so we can resolve it quickly.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Refunds</h2>
      <p className="mb-4">Refunds are assessed case-by-case. This does not affect your statutory rights.</p>
    </div>
  );
};

export default DeliveryAndRefunds;





